export const colors = {
  TEXT_PRIMARY: '#213053',
  TEXT_GREEN: '#4CAF50',
}
